module.exports = __webpack_public_path__ + "static/media/computer.95eadb91.png";